import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import IconButton from '@mui/material/IconButton';
import { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';

import 'yet-another-react-lightbox/styles.css';

interface IEvidenceProps {
  evidences: string[];
}

const Evidence = (props: IEvidenceProps) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="evidences">
      <IconButton onClick={() => setOpen(true)} title="Ver evidencias">
        <RemoveRedEyeOutlinedIcon />
      </IconButton>
      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={props.evidences.map((e) => ({ src: e }))}
      />
    </div>
  );
};

export default Evidence;
